import { render } from "./dashboard_organizer_contract.vue?vue&type=template&id=de2a67c8&scoped=true"
import script from "./dashboard_organizer_contract.vue?vue&type=script&lang=js"
export * from "./dashboard_organizer_contract.vue?vue&type=script&lang=js"

import "./dashboard_organizer_contract.vue?vue&type=style&index=0&id=de2a67c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de2a67c8"]])

export default __exports__